module.exports = __webpack_public_path__ + "img/city_taoyuan.3d799344.png";